import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import {Box, ThemeProvider } from '@mui/material';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const SalesReturn = (props) => {
  const { sale_pharm } = useParams();

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
  const [opbillData, setopbillData] = useState([]);
  const [disc, setDisc] = useState(opbillData[0]?.disc || 0);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [lres, setLres] = useState([]);
  const [lnet, setLnet] = useState([]);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [disPer, setDisPer] = useState(0);
  const [changed, setChanged] = useState(false);

  const [pharmData,setpharmData]=useState({
        "return_no":'',
        "return_type":'',
        "pat":'',
        "patient":'',
        "product":'',
        "qty":'',
        "netamount":'',
        "total":'',
        "details":'',
        "sale_id":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
     });
  useEffect(() => {
    try {
      axios.get(baseUrl + 'pharm-invoice-other/' + sale_pharm)
        .then(function (response) {
          setopbillData(response.data);
          setLres(response.data[0].qty.split(','));
          setLnet(response.data[0].netamount.split(','));
          setDisc(parseFloat(response.data[0].disc));
        });

    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (opbillData.length > 0) {
      fetchPharmData();
    }
  }, [opbillData]);

      function fetchPharmData() {
        const ipIds = opbillData.map(row => row.product.split(',').map(item => item.trim()));

        ipIds.forEach(ipId => {
          try {
            ipId.forEach(id => {
              axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
                .then(function (response) {
                  const data = Object.assign({}, response.data);
                  setViewPharmData(prevData => [...prevData, data]);
                })
                .catch(function (error) {
                  console.log(error);
                });
            });
          } catch (error) {
            console.log(error);
          }
        });
      }

  const handleKeyDown = (e, uniqueKey) => {
    switch (e.keyCode) {
       case 90:
          e.preventDefault();
            handleDeleteRow(e, uniqueKey);
          break;
    }
    };


  const inputRefs = useRef([]);
  useEffect(() => {
    inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [viewPharmData.length]);


  const handleDeleteRow = (e, uniqueKey) => {
  const [rowIndex, subIndex] = uniqueKey.split('-');
  const newOpbillData = [...opbillData];

  newOpbillData[rowIndex].product = newOpbillData[rowIndex].product
    .split(',')
    .filter((_, index) => index !== parseInt(subIndex))
    .join(',');

  const newLnet = lnet.filter((_, index) => index !== parseInt(subIndex));
  const newLres = lres.filter((_, index) => index !== parseInt(subIndex));

  // Update the indexes in newOpbillData
  newOpbillData.forEach((row) => {
    const products = row.product.split(',').map((product) => parseInt(product));
    const updatedProducts = products.map((product) => {
      if (product > parseInt(uniqueKey)) {
        return product; // Adjust the index of products after deletion
      }
      return product;
    });
    row.product = updatedProducts.join(',');
  });

  setLnet(newLnet);
  setLres(newLres);
  setopbillData(newOpbillData);
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setpharmData(prevState => ({ ...prevState, [name]: value }));
  };



const handleAmountChange = (e, subIndex) => {
  const newLnet = [...lnet];
  const qty = parseFloat(e.target.value);
  const uamount = parseFloat(e.target.getAttribute('data-uamount'));
  const totqty = parseFloat(e.target.getAttribute('data-totqty'));

   if (qty > totqty) {
    Swal.fire("Stock not available");
    const updatedQty = totqty.toString(); // Convert totqty to string
    const updatedLres = lres.map((item, i) =>
      i === subIndex ? updatedQty : item
    );
    setLres(updatedLres);
    e.target.value = updatedQty; // Update the input field value
  }
  const netamount = qty * uamount;
  newLnet[subIndex] = netamount;
  setLnet(newLnet);

};
const handleDisPerChange = (e) => {
   const newDisPer = parseFloat(e.target.value) || 0;
   setDisPer(newDisPer);
  };
useEffect(() => {
  let subTotal = 0;
  let disc1 = disc || 0;
  let newTotal = 0;

  subTotal += arraySum(lnet);
  if(disc==0){
  disc1 = subTotal * (parseFloat(disPer) / 100);
  }else{
   disc1 = disc;
  }
  newTotal = subTotal - disc1;

  setSubTotal(subTotal);
  setDisPer(disPer);
  setDisc(disc1);
  setTotal(newTotal);
}, [lnet, disPer]);
const arraySum = (arr) => {
    return arr.reduce((total, value) => total + parseFloat(value), 0);
  };

    const formSubmit = (e) => {
      e.preventDefault();
        const patid = document.getElementById("patid").value;
        const sale_id = document.getElementById("sale_id").value;
        const patient = document.getElementById("patient").value;
        const dbType = document.getElementById('dbType').value;
        const details = document.getElementById("details").value;

         const ids = [];
         const qtys = [];
         const netamounts = [];
     opbillData.forEach((row, index) => {
          const productParts = row.product.split(',');
          const productNumbers = productParts.map(part => Number(part.trim()));
          ids.push(...productNumbers);
          qtys.push(...lres.map(Number));
          netamounts.push(lnet);
        });
        const qtyMap = {};
        qtys.forEach((row, index) => {
          const elementId = `totqty-${index}`;
          const totqty = document.getElementById(elementId).value;
           qtyMap[ids[index]] = Number(totqty) + qtys[index];
        });

          axios.post(`${baseUrl}get_sale_return/`)
          .then(response => {
          const sale_return = response.data.value;
          const _formData = new FormData();
          _formData.append('return_no', sale_return);
          _formData.append('return_type', dbType);
          _formData.append('sale_id', sale_id);
          _formData.append('pat', patid);
          _formData.append('patient', patient);
          _formData.append('product', ids.map(id => id).join(','));
          _formData.append('qty', qtys);
          _formData.append('netamount', netamounts.join(','));
          _formData.append('total', total.toFixed(2));
          _formData.append('details', details);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}pharm-sale-return/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                ids.forEach(id => {
                  const pharmData = {
                    product: id,
                    qty: qtyMap[id],
                    ip_add: ipAddress,
                  };
                  axios.put(`${baseUrl}update-indent-use/${id}/`, pharmData)
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error);
                    });
                });
                Swal.fire({
                  title: 'Pharmacy Return Bill Generated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.href = '/pharm-invoice-return/' + sale_return + '/';
                  }, 3000);
              }
            })

            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };


  return (
  <section className="container mt-4">
  <form>
   <div className="row table-responsive">
    <div className='col-md-12 col-12 mb-2'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Sale ID</th>
          <th>Billed On</th>
        </tr>
      </thead>

      <tbody>
        {opbillData.map((pat, index) => (
          <tr key={index}>
            <td style={{width:'10%'}}><input className="form-control" type="text" name="patid" id="patid" value={pat.pat?.id} readOnly/></td>
            <td style={{width:'20%'}}><input className="form-control" type="text" name="patient" id="patient" value={pat?.patient} readOnly/></td>
            <input className="form-control" type="hidden" name="sale_id" id="sale_id" value={pat.id} readOnly/>
            <td style={{width:'20%'}}><input className="form-control" type="text" value={pat.sale_id} readOnly/></td>
            <td style={{width:'10%'}}><input className="form-control" type="text" name="addedon" id="addedon" value={pat.add_date} readOnly/></td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
   </div>
    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                <th style={{width: 60}}>ID</th>
          <th style={{width: 170}}>Drug Name</th>
          <th style={{width: 50}} >Qty</th>
          <th style={{width: 100}}>Batch</th>
          <th style={{width: 90}}>Expiry</th>
          <th style={{width: 50}} >Qty in Stock</th>
          <th style={{width: 110}} >MRP 1s</th>
          <th style={{width: 110}}>Net Amount</th>
        </tr>
      </thead>

      <tbody>
    {opbillData.map((row, index) => {
      return row.product.split(',').map((test, subIndex) => {
        const pharmData = viewPharmData.find((data) => data.id === parseInt(test));
            const uniqueKey = `${index}-${subIndex}`;
        return (
        <tr key={uniqueKey}>
        <td>
        <input
            type="text"
            name={`id-${index}`}
            id={`id-${index}`}
            value={pharmData?.id}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60}}
            tabIndex={-1}
            readOnly
          />
         </td>
         <td>
        <input
         type="text"
          style={{ width: 200 }}
              className="ms-4 me-2"
          value={pharmData?.product.product}

          readOnly
        />
        </td>
         <td>
          <input
              type="number"
              style={{ width: 90 }}
              className="ms-4 me-2"
              name={`qty-${index}`}
              id={`qty-${index}`}
              value={lres[subIndex]}
              data-uamount={pharmData?.product.uamount} // Use data-uamount attribute to store the value
              data-totqty={pharmData?.qty} // Add the data-totqty attribute
               onChange={(e) => {
                  const updatedLres = lres.map((item, i) =>
                    i === subIndex ? e.target.value : item
                  );
                  setLres(updatedLres);
                  handleAmountChange(e, subIndex);
                }}
              onKeyDown={(e) => handleKeyDown(e, uniqueKey)}
              tabIndex={0}
              min={1}
              max={lres[subIndex]}
              required
            />
            </td>
         <td>
            <input
              type="text"
              style={{width: 110}}
              name="batch"
              value={pharmData?.product.batch}
              onChange={(e) => handleChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
            <td>
            <input
              type="text"
              className="ms-4 me-2"
              style={{width: 90}}
              name="expiry"
              value={pharmData?.product.expiry}
              onChange={(e) => handleChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-4 me-2"
              style={{width: 90}}
              name={`totqty-${subIndex}`}
              id={`totqty-${subIndex}`}
              value={pharmData?.qty}
              onChange={(e) => handleChange(e, subIndex)}
              tabIndex={-1}
              readOnly
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-4 me-2"
              style={{width: 90}}
              name="uamount"
              value={pharmData?.product.uamount}
              onChange={(e) => handleAmountChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-4 me-2"
              style={{width: 140}}
              name={`netamount-${index}`}
              id={`netamount-${index}`}
              value={lnet[subIndex]}
              tabIndex={-1}
              readOnly
            />
            </td>

             <button style={{display: 'none'}} className="btn btn-danger" type="button" onClick={(e) => handleDeleteRow(e, uniqueKey)}>Delete</button>


        </tr>
        );
      });
    })}
      </tbody>
      </table>
  <div className="row ms-5 mt-5">

  <div className="col-md-6">
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
    <div className="form-group">
      <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} value={subtotal} readOnly />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">%</div>
        <input
          type="number"
          value={disPer}
          name="disPer"
          id="disPer"
          onChange={handleDisPerChange}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input
          type="number"
          onChange={handleChange}
          name="disc"
          id="disc"
          value={disc}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} name="tot" value={total} readOnly />
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Choose Payment Type</label>
      <select name="dbType" id="dbType" >
        <option value="Cash">Cash</option>
        <option value="Cashless">CashLess</option>
      </select>
    </div>
    <div className="form-group">
      <label>Details:</label>
      <textarea
        className="no-comma form-control"
        tabIndex="0"
        name="details"
        id="details"
        rows={2}
        cols={2}
      ></textarea>
    </div>
  </div>
</div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button" onClick={formSubmit}  className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default SalesReturn;
